exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BasemapList {\n    max-height: 270px;\n    overflow-y: auto;\n    overflow-y: overlay;\n    margin-left: 7px;\n}\n\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/layers/basemaps/BasemapList.css
// module id = 1000
// module chunks = 0